import { type JSX } from 'react';

export const Chevron = (): JSX.Element => {
  return (
    <svg
      fill="currentColor"
      height="100%"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 6 12"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M0.409017 6.69364C0.0361104 6.30639 0.0361104 5.6936 0.409017 5.30635L4.4669 1.09239C4.69078 0.859913 5.06296 0.859913 5.28683 1.09239C5.49907 1.31279 5.49907 1.66156 5.28683 1.88196L1.32131 6L5.28683 10.118C5.49907 10.3384 5.49907 10.6872 5.28683 10.9076C5.06296 11.1401 4.69078 11.1401 4.4669 10.9076L0.409017 6.69364Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
